import mergeRefs from './merge-refs';

export { mergeRefs };

export default mergeRefs;
